// @ts-nocheck
import { App } from "@adyen/adyen-web";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Draft } from "immer";

export type ProductDetailsZoomState = ApplicationState["bunzl"]["pages"]["productDetailsZoom"];

export const initialProductDetailsZoomState: ProductDetailsZoomState = {
    isZoomOpen: false,
};

export const productDetailsZoomActions = {
    "Store/Pages/productDetailsZoom/setIsZoomOpen": (
        draft: Draft<ProductDetailsZoomState>,
        action: { isZoomOpen: boolean },
    ) => {
        draft.isZoomOpen = action.isZoomOpen;
    },
};

const productDetailsZoomReducer = createTypedReducerWithImmer(
    initialProductDetailsZoomState,
    productDetailsZoomActions,
);
export type ProductDetailsZoomActions = BunzlActionUnion<typeof productDetailsZoomActions>;
export default productDetailsZoomReducer;
